import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { useSettings } from '../../context/Settings';
import './Watermark.scss';

export const Watermark = () => {
  const { t, i18n } = useTranslation();
  const location = useLocation();
  const { settings } = useSettings();

  // Don't show watermark on language choose page (root path)
  if (location.pathname === '/' || location.pathname === '/login') {
    return null;
  }

  const getCopyrightText = () => {
    const currentYear = new Date().getFullYear();
    
    // Language-specific watermark configurations
    switch (i18n.language) {
      case 'sv':
        return `© Sanofi ${currentYear} - ${t('watermark.all_rights_reserved')} | MAT-SE-2100803 (ver. 1) maj 2023`;
      
      case 'nl':
        return `© Sanofi ${currentYear} - ${t('watermark.all_rights_reserved')} | MAT-NL-2400377`;
      
      case 'de':
        return `© Sanofi ${currentYear} - ${t('watermark.all_rights_reserved')} | MAT-DE-2503874-1.0 - 10/2025`;
      
      case 'es':
        return `© Sanofi ${currentYear} - ${t('watermark.all_rights_reserved')} | MAT-ES-250246-1.0 – 10/2025`;
      
      case 'en':
      default:
        let matCode = 'MAT-XU-2502193 (v1.0) ';

        if (settings.watermarkContext === 'watch_initiate_insulin') {
          matCode = 'MAT-XU-2502865 (v1.0)';
        } else if (settings.watermarkContext === 'roleplay' || settings.watermarkContext === 'hear_my_story') {
          matCode =  'MAT-XU-2502894 (v1.0)';
        }

        return `© Sanofi ${currentYear} - ${t('watermark.all_rights_reserved')} | ${matCode} ${t('watermark.date_of_preparation')}`;
    }
  };

  return (
    <div className="watermark">
      <span>{getCopyrightText()}</span>
    </div>
  );
};
